import React, { memo, useEffect, useCallback, useMemo } from "react";
import "../HawkeyeV2CreateFilterPanel/HawkeyeV2CreateFilterPanel.scss";
import { useAxiomState } from "__AxiomComponents/AxiomHooks/AxiomHooks";
import Icon from "../Icons/Icon";
import FilterPanelOptions from "../HawkeyeV2CreateFilterPanel/FilterPanelOptions";
import { getSelectedFilters, getAppliedFilters } from "../HawkeyeV2Filters/HawkeyeV2FilterUtils";
function HawkeyeV2EditFilterPanel(props) {
  const {
    editingFilter,
    filterOptions,
    smartFilterRefs,
    editFilter,
    closeEditFilter,
    HawkeyeV2AppSettings,
  } = props;

  const [state, dispatch] = useAxiomState(
    {
      selectedFilter: null,
      filterSaveName: "",
      filterValues: [],
      isFetchingValues: false,
      isOverridingFilter: false,
      selectedFilters: [],
      isPublic: false,
      errorMessage: null,
    },
    props.appName,
    props.appID,
    "HawkeyeV2CreateFilterPanel",
    props.componentID
  );

  // Set filter values from selected filter for editing
  useEffect(() => {
    const updatedFilter = getAppliedFilters(editingFilter, [], filterOptions);
    const selectedFilters = updatedFilter[0].filterSettings;
    dispatch({
      filterSaveName: editingFilter.filterName,
      selectedFilters: selectedFilters,
      selectedFilter: selectedFilters[0].filter,
      isPublic: editingFilter.isPublic,
    });
    dispatch(
      {
        filters: selectedFilters,
        smartFilterRefs: smartFilterRefs,
      },
      "AxiomEvent",
      "onApplyFilter"
    );
  }, [dispatch, filterOptions, editingFilter, smartFilterRefs]);

  // Get filter values on selected filter change
  useEffect(() => {
    if (state.selectedFilter) {
      dispatch({
        isFetchingValues: true,
        filterValues: [],
      });
      dispatch(
        {
          filter: state.selectedFilter,
          smartFilterRefs: smartFilterRefs,
          HawkeyeV2AppSettings: HawkeyeV2AppSettings,
        },
        "AxiomEvent",
        "getFilterValues"
      );
    }
  }, [dispatch, state.selectedFilter, smartFilterRefs, HawkeyeV2AppSettings]);

  const onFilterSelection = useCallback(
    (selectedFilter) => {
      const d1 = { ...selectedFilter };
      delete d1["component"];
      dispatch({ selectedFilter: d1 });
    },
    [dispatch]
  );

  const onFilterValueSelection = useCallback(
    (selectedValues) => {
      const filterValues = selectedValues.map((value) => value.displayName);
      const newSelectedFilters = getSelectedFilters(
        state.selectedFilters,
        state.selectedFilter,
        filterValues
      );

      dispatch(
        {
          filters: [
            {
              filter: state.selectedFilter,
              values: filterValues,
            },
          ],
          smartFilterRefs: smartFilterRefs,
        },
        "AxiomEvent",
        "onApplyFilter"
      );

      dispatch({
        selectedFilters: newSelectedFilters.filter((f) => f.values.length),
        errorMessage: null,
      });
    },
    [dispatch, state.selectedFilter, state.selectedFilters, smartFilterRefs]
  );

  const resetSavedFilters = useCallback(() => {
    if (state.selectedFilters.length > 0) {
      dispatch(
        (state) => ({
          filters: state.selectedFilters,
          smartFilterRefs: smartFilterRefs,
        }),
        "AxiomEvent",
        "onRemoveFilter"
      );
    }
  }, [dispatch, smartFilterRefs, state.selectedFilters.length]);

  const closeEditWindow = useCallback(() => {
    resetSavedFilters();
    closeEditFilter();
  }, [closeEditFilter, resetSavedFilters]);

  const onEditFilter = () => {
    const { filterSaveName, selectedFilters } = state;
    if (selectedFilters.length === 0 && editingFilter.isSaveFilterRequired == true) {
      dispatch({
        errorMessage: "Please select filter to save",
      });
      return;
    } else if (selectedFilters.length === 0 && editingFilter.isSaveFilterRequired == false) {
      dispatch({
        errorMessage: "Please select filter to apply",
      });
      return;
    } else {
      dispatch({
        errorMessage: null,
      });
    }
    editFilter(
      editingFilter.filterID,
      filterSaveName,
      selectedFilters,
      state.isPublic,
      editingFilter.isSaveFilterRequired
    );
    closeEditWindow();
  };

  const updateFilterSaveName = (event) => {
    const filterSaveName = event.target.value;
    dispatch({
      filterSaveName,
      isOverridingFilter: false,
      errorMessage: null,
    });
  };

  const onResetAll = () => {
    dispatch({
      isReset: true,
      selectedFilter: null,
      filterValues: [],
      isFetchingValues: false,
      isOverridingFilter: false,
      selectedFilters: [],
      isPublic: false,
      errorMessage: null,
    });
    resetSavedFilters();
  };
  const filterOptionsData = useMemo(() => {
    if (state.isReset == true) {
      dispatch({
        isReset: false,
      });
    }
    return filterOptions.map((d) => {
      return { ...d };
    });
  }, [filterOptions, dispatch, state.isReset]);
  return (
    <div className="HawkeyeV2CreateFilterPanel">
      <div className="top-bar">
        Edit filter {editingFilter.filterName}
        <div className="close-button" onClick={closeEditWindow}>
          <Icon icon="ICON_CLOSE" className="hawkeye-close-tag-icon" />
        </div>
      </div>
      <FilterPanelOptions
        appID={props.appID}
        appName={props.appName}
        componentID={`${props.componentID}_FilterOptions`}
        filterOptions={filterOptionsData}
        onSelection={onFilterSelection}
        isFetchingValues={state.isFetchingValues}
        filterValues={state.filterValues}
        onFilterValueSelection={onFilterValueSelection}
        selectedFilters={state.selectedFilters}
        editingFilter={editingFilter}
        selectedFilter={state.selectedFilter}
      ></FilterPanelOptions>
      <div className="save-filters">
        <div className="save-filter-label">Save Filter</div>
        <div className="filter-value-button">
          <div className="filter-value">
            <input
              type="text"
              placeholder="Enter filter name to save"
              value={state.filterSaveName}
              onChange={updateFilterSaveName}
              className={`${state.errorMessage != null ? "error-message" : ""}`}
            ></input>
          </div>
          <div className="save-button" onClick={onEditFilter}>
            {" "}
            SAVE{" "}
          </div>
        </div>
        {state.errorMessage != null && (
          <div className="error-message-label">
            <Icon icon="ICON_ERROR" className="hawkeye-filter-error-icon" />
            {state.errorMessage}
          </div>
        )}
        <div className="reset-filter-button">
          <div className="reset-button" onClick={onResetAll}>
            RESET
          </div>
          <div className="filter-button" onClick={onEditFilter}>
            FILTER RESULT
          </div>
        </div>
      </div>
    </div>
  );
}

export default memo(HawkeyeV2EditFilterPanel);
